var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOwnerConcernsV3(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5, _ref6;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.5031 9.1663V8.18984C17.5031 7.72941 17.1298 7.35616 16.6694 7.35616H12.6438V3.33054C12.6438 2.87011 12.2705 2.49686 11.8101 2.49686H8.18981C7.72938 2.49686 7.35612 2.87011 7.35612 3.33054V7.35616H3.33051C2.87008 7.35616 2.49683 7.72941 2.49683 8.18984V11.8101C2.49683 12.2706 2.87008 12.6438 3.33051 12.6438H7.35612V16.6694C7.35612 17.1299 7.72938 17.5031 8.18981 17.5031H9.99995",
    stroke: "#7A7670",
    style: (_ref2 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0018 14.1684V14.1684C16.3831 14.1684 17.5028 15.2882 17.5028 16.6694V16.6694C17.5028 17.1299 17.1296 17.5031 16.6691 17.5031H13.3344C12.874 17.5031 12.5007 17.1299 12.5007 16.6694V16.6694C12.5007 15.2882 13.6205 14.1684 15.0018 14.1684Z",
    stroke: "#7A7670",
    style: (_ref3 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2107 11.6676C15.2106 11.7827 15.1172 11.8758 15.0022 11.8758C14.8872 11.8757 14.7939 11.7825 14.7939 11.6675C14.7938 11.5524 14.887 11.4591 15.002 11.4589C15.0574 11.4589 15.1105 11.4808 15.1497 11.52C15.1888 11.5591 15.2108 11.6123 15.2107 11.6676",
    stroke: "#7A7670",
    style: (_ref4 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref4, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref4, "strokeOpacity", 1), _ref4),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7112 12.5013C17.7111 12.6163 17.6177 12.7095 17.5027 12.7095C17.3877 12.7094 17.2944 12.6162 17.2944 12.5011C17.2943 12.3861 17.3875 12.2928 17.5025 12.2926C17.5579 12.2925 17.611 12.3145 17.6502 12.3537C17.6893 12.3928 17.7113 12.4459 17.7112 12.5013",
    stroke: "#7A7670",
    style: (_ref5 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref5, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref5, "strokeOpacity", 1), _ref5),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7095 12.5013C12.7093 12.6163 12.616 12.7095 12.501 12.7095C12.3859 12.7094 12.2927 12.6162 12.2926 12.5011C12.2926 12.3861 12.3858 12.2928 12.5008 12.2926C12.5562 12.2925 12.6093 12.3145 12.6484 12.3537C12.6876 12.3928 12.7096 12.4459 12.7095 12.5013",
    stroke: "#7A7670",
    style: (_ref6 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref6, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref6, "strokeOpacity", 1), _ref6),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnerConcernsV3);
export default __webpack_public_path__ + "static/media/ownerConcernsV3.b96f65917999f4d6aa24d3e5a2659d60.svg";
export { ForwardRef as ReactComponent };